import React from "react"
import { navigate } from "aldoo-ra/Navigate"
import Modal from "aldoo-ra/Modal"
import Button from "aldoo-ra/Button"
import Typography from "aldoo-ra/Typography"
import TextBundle from "aldoo-ra/CMS/text-bundle"
import PubSub from "pubsub-js"

const TechnicalSupportDialog = ({ isOpen, onClose, onContinue }) => {
  const texts = TextBundle({ id: "support_dialog" });

  return (
    <Modal
      title={texts?.title || "You're having trouble using our product?"}
      isOpen={isOpen}
      onClose={onClose}
      variant="aqua_medium"
      className="md:max-w-[560px]"
    >
      <div className="flex flex-col max-w-[320px] md:max-w-full items-center md:items-start gap-14 md:gap-12 pt-14 md:pt-10 mx-auto md:mx-0">
        <div className="flex flex-col items-center md:items-start gap-3">
          <Typography
            variant="info_18"
            className="text-text my-0"
          >
            {texts?.paragraph_1 || "There is a high chance we can fix that."}
          </Typography>

          <Typography
            variant="info_18"
            className="text-text my-0"
          >
            {texts?.paragraph_2 || "Please select one of the following:"}
          </Typography>
        </div>

        <div className="space-y-4 w-full">
          {/* Contact Support button */}
          <Button
            variant="secondary_s"
            onClick={() => navigate("https://aquamail.freshdesk.com/support/tickets/new")}
            className="w-full"
          >
            {texts?.cta_support || "Contact Support"}
          </Button>

          {/* Help Center button */}
          <Button
            variant="secondary_s"
            onClick={() => navigate("https://aquamail.freshdesk.com/support/home")}
            className="w-full"
          >
            {texts?.cta_help_center || "Check Help Center"}
          </Button>

          {/* Continue to Cancel button */}
          <Button
            variant="secondary_s"
            onClick={onContinue}
            className="w-full"
          >
            {texts?.cta_continue || "Continue to Cancel"}
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default TechnicalSupportDialog
